export default function Page404(): JSX.Element {
  return (
    <div className="flex h-screen">
      <div className="m-auto text-center">
        <h1 className="text-7xl font-bold">404</h1>
        <p className="text-center text-2xl">Page not found</p>
      </div>
    </div>
  );
}
